/**
 * Phase 1.7 — page-level layout picker.
 *
 * Some pages have completely different v1 vs v2 bodies (HomePage,
 * AnimalsPage). Routes wire them up with `<LayoutPicker v1={...} v2={...} />`
 * which inspects the layout flag and renders the matching body. The
 * outer chrome (AppShell vs AppLayout) is still chosen by AuthGuardV2 —
 * this picks the *content*, not the chrome.
 *
 * Pages without a v2 body simply use the v1 body in both layouts; the
 * AppShell can host any v1 page (the v1 page just doesn't use any v2
 * primitives, but renders fine).
 */

import type { ReactElement } from 'react';
import { useLayout } from '@/lib/layout-flag';

export function LayoutPicker({ v1, v2 }: { v1: ReactElement; v2: ReactElement }): ReactElement | null {
  const layout = useLayout();
  if (layout === null) return null;
  return layout === 'v2' ? v2 : v1;
}
